/**
 * @component App
 * @description
 * Componente raíz de la aplicación. Configura el layout general, aplica clases según el navegador del usuario,
 * muestra el contenido principal (`Content`), así como Navbar, Footer, Panel de Configuración, y controla el modo fullscreen.
 */

import React, { useEffect, useContext } from 'react';
import is from 'is_js';

import NavbarTop from 'components/navbar/navbar-top/NavbarTop';
import Content from 'components/content/content.jsx';
import Footer from 'components/footer/Footer';

import AppContext from 'config/app-context';
import PreventScreenshot from 'hooks/preventScreenshot';

const $ = require('jquery');
$.DataTable = require('datatables.net');

function App() {
	// Acceso a la configuración global de AppContext
	const { config: { isFluid, isFullscreen, navbarPosition } } = useContext(AppContext);

	// Referencia a la clase del tag <html>
	const HTMLClassList = document.getElementsByTagName('html')[0].classList;

	/**
	 * Efecto para agregar clases específicas al HTML según el sistema operativo o navegador detectado.
	 */
	useEffect(() => {
		if (is.windows()) HTMLClassList.add('windows');
		if (is.chrome()) HTMLClassList.add('chrome');
		if (is.firefox()) HTMLClassList.add('firefox');
		if (is.safari()) HTMLClassList.add('safari');
	}, [HTMLClassList]);

	/**
	 * Efecto para aplicar el layout de navegación doble si se selecciona esa configuración.
	 */
	useEffect(() => {
		if (navbarPosition === 'double-top') HTMLClassList.add('double-top-nav-layout');
		return () => HTMLClassList.remove('double-top-nav-layout');
	}, [navbarPosition, HTMLClassList]);

	return (
		<>
			{/* Hook para prevenir screenshots */}
			<PreventScreenshot />

			{/* Si está en modo fullscreen, solo se muestra el contenido */}
			{isFullscreen ? (
				<Content />
			) : (
				<>
					{/* Contenedor fluido o fijo dependiendo de configuración */}
					<div className={isFluid ? 'container-fluid' : 'container'}>
						{/* Navbar lateral si se desea incluir */}
						{/* {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
							<NavbarVertical />
						)} */}

						<div className="content px-8">
							<NavbarTop />
							<Content />
							<Footer />
						</div>
					</div>

					{/* Panel de configuración 
						<SettingsToggle />
						<SettingsPanel />
					*/}
				</>
			)}
		</>
	);
}

export default App;